<template>
  <div class='chart'>
    <chart-sankey :data='chartData' :config='chartConfig'></chart-sankey>
  </div>
</template>

<script>
  import { ChartSankey } from 'vue-d2b'

  export default {

    data () {
      return {
        chartData: {
          nodes: [
            {name: 'Node A'},
            {name: 'Node B'},
            {name: 'Node C'},
            {name: 'Node D'},
            {name: 'Node E'}
          ],
          links: [
            {source: 'Node A', target: 'Node E', value: 2},
            {source: 'Node A', target: 'Node C', value: 2},
            {source: 'Node B', target: 'Node C', value: 2},
            {source: 'Node B', target: 'Node D', value: 2},
            {source: 'Node C', target: 'Node D', value: 2},
            {source: 'Node C', target: 'Node E', value: 2},
            {source: 'Node D', target: 'Node E', value: 4}
          ]
        },

        chartConfig (config) {
          config
            .sankey()
            .sankey()
            .nodePadding(100)

          config
            .sankey()
            .nodeDraggableY(true)
        }
      }
    },

    name: "sankey",

    components: {
      ChartSankey
    }
  }
</script>

<style lang="less" scoped>
.graph {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column wrap;
}

.viewport {
  width: 100%;
  flex: 1 1 auto;
}
</style>
